var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative-position"},[_c('price-config-items-header',{attrs:{"model":_vm.model},on:{"save":_vm.saveChanges,"cancel":_vm.cancelChanges}}),_c('div',{ref:"mountPoint"}),_c('loading',{attrs:{"is-show":_vm.isPending}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }